import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import TextAreaInput from "../UI/Input/TextAreaInput";
import Card from "@mui/material/Card";
import FileUploader from "../FileUploader";
import DeleteIcon from '@mui/icons-material/Delete';
const EditOutletDetails = () => {
let history = useHistory();
let { id } = useParams();
const [outlet, setOutlet] = useState({
    outlet_name: '',
    restro_id: '',
    outlet_id: '',
    airmenu_id:'',
    contact:'',
    email:'',
    address: '',
   description: '',
   instagram_url: '',
   facebook_url: '',
   menu_link:'',
   twitter_url	:'',
   status: '',
});
const [selectedFile, setSelectedFile] = useState(null);
const [showapp, setShowapp] = useState(0);
const [showweb, setShowweb] = useState(0);
const [loading, setloading] = useState(false);
const { description,instagram_url,facebook_url,twitter_url,menu_link,address,outlet_name,restro_id,outlet_id,airmenu_id,contact,email,status } = outlet;

const onInputChange = e => {
setOutlet({ ...outlet, [e.target.name]: e.target.value })
console.log(outlet);
}
useEffect(() => {
edit();
}, []);
console.log(id)
const edit = async () => {
await axios.post(endpoints.editOutletDetails, { id: id }).then((response) => {
setOutlet({
id: response.data.data.id,
outlet_name: response.data.data.outlet_name,
restro_id: response.data.data.restro_id,
outlet_id: response.data.data.outlet_id,
airmenu_id: response.data.data.airmenu_id,
contact: response.data.data.contact,
email: response.data.data.email,
menu_link: response.data.data.menu_link,
description: response.data.data.description,
address: response.data.data.address,
instagram_url: response.data.data.instagram_url != 'null' ? response.data.data.instagram_url : '',
facebook_url: response.data.data.facebook_url != 'null' ? response.data.data.facebook_url : '',
twitter_url: response.data.data.twitter_url != 'null' ? response.data.data.twitter_url : '',


});
console.log(response.data.data.id,)
setShowapp(response.data.data.show_app);
setShowweb(response.data.data.show_web);
});
}
const setStatus = async (e, type) => {
if (e.target.checked) {
var status = 1
}
else {
var status = 0
}
if (type == 'app') {
setShowapp(status);
} else {
setShowweb(status);
}
}
const onSubmit = async e => {
    setloading(true);
    e.preventDefault();
// if (!selectedFile) {
//     alert('Please select icon');
//     return false;
// }
// if (!selectedFileImage) {
//     alert('Please select image');
//     return false;
// }
const formData = new FormData();
formData.append("outlet_name", outlet_name);   
        formData.append("restro_id", restro_id);
        
        formData.append("description", description);
        formData.append("instagram_url", instagram_url);
        formData.append("facebook_url", facebook_url);
        formData.append("twitter_url", twitter_url);
        formData.append("address", address);
      
        formData.append("email", email);
        formData.append("contact", contact);

        formData.append("airmenu_id", airmenu_id);
        formData.append("outlet_id", outlet_id);
    
        formData.append("menu_link", selectedFile);



formData.append("status", status);
formData.append("id", id);
await axios.post(endpoints.updateOutletDetails, formData).then((response) => {
setloading(false);
history.goBack();
// if (response.data.status == 200) {
//     // toast.success(response.data.message);
//     history.goBack();
// } else {
//     // toast.error(response.data.message);
// }
});
}
const removeImageHandler = async (id, type) => {
await axios.post(endpoints.deleteOutletDetailsImage,{id, type}).then((response) => {
});
window.location.reload();
};
return (
<div className="ui main">
   <h2>Edit OutletDetails</h2>
   <Card className="px-3 py-3">
                <form className="ui form" onSubmit={e => onSubmit(e)} encType="multipart/form-data">
                    <div className="row">
                        {/* <div className="col col-6">
                            <label>Restaurents </label>
                            <select name="restro_id" required className="form-control" onChange={e => onInputChange(e)} >
                                <option value="">Select Restaurents</option>
                                {rest.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name}</option>;
                                })}
                            </select>
                        </div> */}

                        <Input id="outlet_name" label="Outlet Name" type="text" name="outlet_name" place="outlet_name" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={outlet_name} class="col col-6"
                        />
                  <Input id="restro_id" label="restro_id" type="number" name="restro_id" place="restro_id" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={restro_id} class="col col-6"
                        />

                    </div>
                    <div className="row">
                        <Input id="airmenu_id" label="Airmenu_id" type="number" name="airmenu_id" place="airmenu_id" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={airmenu_id} class="col col-6"
                        />
                        <Input id="outlet_id" label="outlet_id" type="number" name="outlet_id" place="outlet_id" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={outlet_id} class="col col-6"
                        />
                        </div>

                   
                    <div className="row">
                        <Input id="instagram_url" label="Instagram Url" type="text" name="instagram_url" place="instagram_url" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={instagram_url} class="col col-6"
                        />
                        <Input id="facebook_url" label="Facebook Url" type="text" name="facebook_url" place="facebook_url" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={facebook_url} class="col col-6"
                        />
                        </div> 

                        <div className="row">
                        <Input id="twitter_url" label="Twitter Url" type="text" name="twitter_url" place="twitter_url" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={twitter_url} class="col col-6"
                        />
                        <Input id="email" label="Email" type="text" name="email" place="email" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={email} class="col col-6"
                        />
                        </div>
                        <div className="row">
                        <Input id="contact" label="Contact" type="number" name="contact" place="contact" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={contact} class="col col-6"
                        />
                        {/* <Input id="email" label="Email" type="text" name="email" place="email" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={email} class="col col-6"
                        /> */}
                        </div>

                        <div className="row">
                        <TextAreaInput id="description" label="description" type="text" name="description" place="description" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={description} class="col col-6"
                        />
                       <div className="col col-6">
                            <label>Status</label>
                            <select name="status" required className="form-control" onChange={e =>
                  onInputChange(e)} value={status}>
                  <option value="">Select Status</option>
                  <option value="2">InActive</option>
                  <option value="1">Active</option>
               </select>
                        </div>
                        </div>
                        <div className="col col-4">
               <label>Menu Link</label>
               
               {(menu_link!=="https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/") ? (
               <div className="mt-3">
                  <img src={menu_link} height="200px" width="200px" className="px-2" />
                  <Button variant="outlined" color="error" size="small" startIcon={
                  <DeleteIcon />
                  } onClick={() => removeImageHandler(id, 'menu_link')}>
                  {/* Delete */}
                  </Button>
               </div>
               ) :
               <FileUploader
                  onFileSelectSuccess={(file) =>
               setSelectedFile(file)}
               onFileSelectError={({ error }) => alert(error)}
               />}
            </div>
                    <div className="row">
                        <div className="col col-6">
                            <div className="mt-3">
                                <LoadingButton
                                    type="submit"
                                    loading={loading}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                            </div></div></div>


                </form>
            </Card>
</div>
);
}
export default EditOutletDetails;